import { Component, OnInit } from '@angular/core';
import {CategoriesService} from '../../services/categories.service';
import {Category} from '../../models/category.model';
import {StatesService} from '../../services/states.service';
import {State} from '../../models/state.model';
import {Filter} from '../../models/filter.model';
import {FilteroffersService} from '../../services/filteroffers.service';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-card-filter',
  templateUrl: './card-filter.component.html',
  styleUrls: ['./card-filter.component.css']
})
export class CardFilterComponent implements OnInit {

  constructor(private categoriesService: CategoriesService,
              private filterOffersService: FilteroffersService,
              private router: Router,
              private route: ActivatedRoute,
              private statesService: StatesService) { }

  categories: Category[] = [];
  selectedCategory: number = -1;
  selectedCategoryMobile: number = -1;

  states: State[] = [];
  selectedState: number = -1;
  selectedStateMobile: number = -1;

  keyWord: string = '';
  keyWordMobile: string = '';

  selectedIdCard: number = 0;

  cardShadowed: string = '';

  lastPage: number = 1;

  ngOnInit() {

    // console.log('Entró a card-filter component... ');

    var idCard = this.route.snapshot.params['cardId'];
    this.selectedIdCard = idCard;

    this.lastPage = this.route.snapshot.params['page'];

    if(this.lastPage===undefined){
      this.lastPage=1;
    }

    var cardName = this.route.snapshot.params['cardName'];

    if(cardName!=undefined)
      switch (cardName.toLowerCase()) {
        case 'debito':
          this.selectedIdCard=1
          break;
        case 'clasica':
          this.selectedIdCard=2
          break;
        case 'oro':
          this.selectedIdCard=3
          break;
        case 'platinum':
          this.selectedIdCard=4
          break;
        case 'clic':
          this.selectedIdCard=5
          break;
      }

    this.cardShadowed = 'assets/img/card_shadoweda_' + this.selectedIdCard + '.png';

    // console.log('cardShadowed: ' + this.cardShadowed);


    this.categoriesService.getCategories().subscribe((categories: Category[]) => {
      this.categoriesService.setCategories(categories);
      this.categories=categories;
    });

    this.statesService.getStates().subscribe((states: State[]) => {
      this.statesService.setStates(states);
      this.states = states;
    });


  }

  filterOffers(){
    // idCard, keyWord, category, state
    let filter = new Filter(this.selectedIdCard, this.keyWord, this.selectedCategory, this.selectedState);
    this.filterOffersService.setSelectedFilter(filter);
  }

  filterOffersMobile(){
    // idCard, keyWord, category, state
    let filter = new Filter(this.selectedIdCard, this.keyWordMobile, this.selectedCategoryMobile, this.selectedStateMobile);
    this.filterOffersService.setSelectedFilter(filter);
  }

  cleanFilter(){
    this.selectedState = -1;
    this.selectedCategory = -1;
    this.keyWord = '';
  }

  cleanFilterMobile(){
    this.selectedStateMobile = -1;
    this.selectedCategoryMobile = -1;
    this.keyWordMobile = '';
  }

  showNearByPromos(){
    // this.selectedCardId = cardId;
    // this.router.navigate(['cardPromos',this.selectedCardId],{skipLocationChange: true, replaceUrl: false});

    this.router.navigate(['nearByPromos',this.selectedIdCard, this.lastPage],{skipLocationChange: true, replaceUrl: false});
  }


}
